define('bindings/knockout.svgicon',["jquery", "knockout"], function ($, ko) {
    var iconSets = {};
    var loadings = {};
    var isIOS = window.cordova && window.cordova.platformId == "ios";

    var getIconset = function(iconset, isUrl) {
        var deferred = new $.Deferred();
        
        if(iconSets[iconset])
        {
            deferred.resolve(iconSets[iconset]);
            return deferred.promise();
        }
        
        if(loadings[iconset])
        {
            loadings[iconset].push(function () {
                deferred.resolve(iconSets[iconset]);
            });
            
            return deferred.promise();
        }
        
        loadings[iconset] = [];
        
        var iconsetUrl = isUrl ? iconset : ("/Content/images/icons/" + iconset + ".svg?v=" + $("body").data("vegzone-appbuild"));
        
        if(window.cordova && !isUrl)
            iconsetUrl = iconsetUrl.substr(1);
        
        $.ajax(iconsetUrl)
            .done(function (svg) {
                iconSets[iconset] = isIOS ? $(svg) : svg;

                deferred.resolve(iconSets[iconset]);
                
                var callbacks = loadings[iconset];
                for(var i=0; i<callbacks.length; i++)
                    callbacks[i](iconSets[iconset]);
            });

        return deferred.promise();
    };

    ko.bindingHandlers.svgicon = {
        init: function(element, valueAccessor, allBindings) {
            var value = valueAccessor();
            var valueUnwrapped = ko.unwrap(value);
            var iconname = "default";
            var iconset = "common";
            var isUrl = false;
            var $element = $(element);
            
            if(typeof valueUnwrapped === "string")
            {
                iconname = valueUnwrapped;
                
                if(iconname.indexOf("#") > 0)
                {
                    isUrl = true;
                    iconset = iconname.split("#")[0];
                    iconname = iconname.split("#")[1];
                }
            } else if(typeof valueUnwrapped === "boolean") {
                iconname = element.dataset.vzIcon;
            } else {
                iconname = valueUnwrapped.icon || iconname;
                iconset = valueUnwrapped.iconset || iconset;
            }

            getIconset(iconset, isUrl).done(function (svg) {
                var icon = isIOS ? svg.find("#" + iconname)[0] : svg.getElementById(iconname);
                var iconIsSymbol = icon.tagName == "symbol";
                
                if(!$element.attr("viewBox")) {
                    if(iconIsSymbol && icon.getAttribute("viewBox")) $element.attr("viewBox", icon.getAttribute("viewBox"));
                    else $element.attr("viewBox", "0 0 100 100");
                }
                
                $element.html(iconIsSymbol ? icon.innerHTML : icon.outerHTML);
            });
        }
    };
    
    return new function () {
        var me = this;
        
        me.updateUse = function(useElement) {
            var $useElement = $(useElement);
            
            me.updateSvgElement($useElement.attr("xlink:href"), $useElement.parent()[0]);
        };
        
        me.updateSvgElement = function (iconname, element) {
            var iconname = iconname;
            var iconset = "common";
            var isUrl = false;
            
            if(iconname.indexOf("#") > 0)
            {
                isUrl = true;
                iconset = iconname.split("#")[0];
                iconname = iconname.split("#")[1];
            }

            getIconset(iconset, isUrl).done(function (svg) {
                try {
                    var icon = isIOS ? svg.find("#" + iconname)[0] : svg.getElementById(iconname);
                    var iconIsSymbol = icon.tagName == "symbol";

                    if (iconIsSymbol && icon.getAttribute("viewBox")) $(element).attr("viewBox", icon.getAttribute("viewBox"));
                    else $(element).attr("viewBox", "0 0 100 100");

                    $(element).html(iconIsSymbol ? icon.innerHTML : icon.outerHTML);
                } catch(e)
                {
                    console.log(e);
                }
            });
        };

        return this;
    };
});

